import state from './moduleEnterpriseVesselEditState.js'
import mutations from './moduleEnterpriseVesselEditMutations.js'
import actions from './moduleEnterpriseVesselEditActions.js'
import getters from './moduleEnterpriseVesselEditGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
